import AppDispatcher from "../Dispatcher";
import AppSDK from "@growthos/ui-app-sdk";
import { AppActionConstants } from "./AppActionConstants";
import AppConfig from "../../AppConfig";
import { fetchWithAuthGet, fetchWithAuthPost } from "../FetchWithAuth";
import BookFiltersStore from "../Stores/BookFiltersStore";

const basePath = AppConfig.getBookApiBasePath();

export const fetchAdSets = (config, campaignUniqueID) => {
	const contextValues = BookFiltersStore.getContextValues();
	return Promise.all([
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/TaxonomyConfiguration/getHeaders/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}`
		),
		fetchWithAuthGet(
			`${basePath.ApiBasePath}/plook/Campaign/getalllineitems/${contextValues.contextId}/${contextValues?.agency?.name}/${contextValues?.client?.name}/${contextValues?.region?.name}/${contextValues?.country?.name}/${config.platform.value}/${config.auditlevel.value}/${campaignUniqueID}`
		)
	]).then((response) => {
		// do something with both responses
		const config = response[0];
		const data = response[1];
		const adSetData = {
			config,
			data
		};
		AppDispatcher.dispatch({
			type: AppActionConstants.fetchAdSet, // "FETCHADSET"
			value: adSetData
		});
	});
};

export const putAdSet = (data, closeModal) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	let type = AppActionConstants.updateAdSetSuccess;
	if (closeModal === false) {
		type = AppActionConstants.createAndAddAdSetSuccess;
	}
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/AdSetSaveViewModel/InsertUpdateAdSets`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type, // "UPDATEADSETSUCCESS or CREATEANDADDADSETSUCCESS"
				value: resp[1].Object
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.updateAdSetFail, // "UPDATEADSETFAIL"
				value: errorObject[1].Object
			});
		});
};

export const editAdSet = (data, row) => {
	/* API ENDPOINT /Book2API/custom/InsertMasterCampaign */

	const user = AppSDK.ApiUser.getUser();
	data.FirstName = user?.givenName;
	data.LastName = user?.familyName;
	data.Email = user?.userName;

	const postData = JSON.stringify(data);
	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/AdSetSaveViewModel/InsertUpdateAdSets`, postData)
		.then((resp) => {
			AppDispatcher.dispatch({
				type: AppActionConstants.editAdSetSuccess, // "EDITADSETSUCCESS"
				value: resp[1].Object,
				row
			});
		})
		.catch(async (error) => {
			const errorObject = await error.details.json();
			AppDispatcher.dispatch({
				type: AppActionConstants.editAdSetFail, // "EDITADSETFAIL"
				value: errorObject[1].Object
			});
		});
};

export const updateAdSetsSheet = (postData) => {
	const user = AppSDK.ApiUser.getUser();
	postData.FirstName = user?.givenName;
	postData.LastName = user?.familyName;
	postData.Email = user?.userName;

	return fetchWithAuthPost(`${basePath.ApiBasePath}/plook/AdSetSaveViewModel/InsertUpdateAdSets`, JSON.stringify(postData));
};
